import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Footer from "./Footer";
import Header from "./Header";
import WebsiteDevelopmentIco1 from "./assets/img/WebsiteDevelopmentIco-1.png";
import WebsiteDevelopmentIco2 from "./assets/img/WebsiteDevelopmentIco-2.png";
import WebsiteDevelopmentIco3 from "./assets/img/WebsiteDevelopmentIco-3.png";
import WebsiteDevelopmentIco4 from "./assets/img/WebsiteDevelopmentIco-4.png";
import WebsiteDevelopmentIco5 from "./assets/img/WebsiteDevelopmentIco-5.png";
import WebsiteDevelopmentIco6 from "./assets/img/WebsiteDevelopmentIco-6.png";
import WebsiteDevelopmentIco7 from "./assets/img/WebsiteDevelopmentIco-7.png";
import seoIco1 from "./assets/img/seoIco-1.png";
import seoIco2 from "./assets/img/seoIco-2.png";
import seoIco3 from "./assets/img/seoIco-3.png";
import seoIco4 from "./assets/img/seoIco-4.png";
import seoIco5 from "./assets/img/seoIco-5.png";
import seoIco6 from "./assets/img/seoIco-6.png";
import seoIco7 from "./assets/img/seoIco-7.png";
import seoIco8 from "./assets/img/seoIco-8.png";
import SocialMediaIco1 from "./assets/img/SocialMediaIco-1.png";
import SocialMediaIco3 from "./assets/img/SocialMediaIco-3.png";
import SocialMediaIco4 from "./assets/img/SocialMediaIco-4.png";
import SocialMediaIco5 from "./assets/img/SocialMediaIco-5.png";
import SocialMediaIco6 from "./assets/img/SocialMediaIco-6.png";
import SocialMediaIco7 from "./assets/img/SocialMediaIco-7.png";
import SocialMediaIco8 from "./assets/img/SocialMediaIco-8.png";
import CustomerEngIco1 from "./assets/img/CustomerEngIco-1.png";
import CustomerEngIco2 from "./assets/img/CustomerEngIco-2.png";
import CustomerEngIco3 from "./assets/img/CustomerEngIco-3.png";
import CustomerEngIco4 from "./assets/img/CustomerEngIco-4.png";
import CustomerEngIco5 from "./assets/img/CustomerEngIco-5.png";
import CustomerEngIco6 from "./assets/img/CustomerEngIco-6.png";
import CustomerEngIco7 from "./assets/img/CustomerEngIco-7.png";
import CustomerEngIco8 from "./assets/img/CustomerEngIco-8.png";
import CMSIco1 from "./assets/img/CMSIco-1.png";
import CMSIco2 from "./assets/img/CMSIco-2.png";
import CMSIco3 from "./assets/img/CMSIco-3.png";
import CMSIco4 from "./assets/img/CMSIco-4.png";
import CMSIco5 from "./assets/img/CMSIco-5.png";
import CMSIco6 from "./assets/img/CMSIco-6.png";
import CMSIco9 from "./assets/img/CMSIco-9.png";
import WorkflowAutoIco1 from "./assets/img/WorkflowAutoIco-1.png";
import WorkflowAutoIco2 from "./assets/img/WorkflowAutoIco-2.png";
import WorkflowAutoIco3 from "./assets/img/WorkflowAutoIco-3.png";
import WorkflowAutoIco4 from "./assets/img/WorkflowAutoIco-4.png";
import WorkflowAutoIco5 from "./assets/img/WorkflowAutoIco-5.png";
import WorkflowAutoIco6 from "./assets/img/WorkflowAutoIco-6.png";
import caseStudyIco1 from "./assets/img/caseStudyIco-1.png";

import productsliderImg1 from "./assets/img/productsliderImg-1.png";
import productsliderImg2 from "./assets/img/productsliderImg-2.png";
import productsliderImg3 from "./assets/img/productsliderImg-3.png";

import opticalCharRecImg1 from "./assets/img/opticalCharRecImg-1.png";
import opticalCharRecImg2 from "./assets/img/opticalCharRecImg-2.png";
import opticalCharRecImg3 from "./assets/img/opticalCharRecImg-3.png";

const DigitalMarketingDetails = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const initialSection = splitLocation[1] || "aiPowered";

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        {(initialSection === "seo" || pathname === "/DigitalMarketing") && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Search Engine Optimization (SEO)</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>Rank Higher. Get Found. Grow Organically.</p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we help businesses increase visibility
                          and attract high-quality traffic through customized
                          SEO strategies. By combining technical optimization,
                          content excellence, and data-driven decisions, we
                          ensure your brand ranks where it matters most—on the
                          first page.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Technical SEO</h2>
                              <p>
                                We audit and improve your website’s
                                architecture, speed, mobile responsiveness, and
                                crawlability to ensure search engines can access
                                and rank your content effectively.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>On-Page SEO</h2>
                              <p>
                                Optimization of keywords, headings, meta tags,
                                internal links, and structured content—aligned
                                with user intent and SEO best practices.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Off-Page SEO & Link Building</h2>
                              <p>
                                We strengthen your site’s authority by building
                                quality backlinks from trusted sources through
                                ethical and strategic outreach.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Strategy & SEO Copywriting</h2>
                              <p>
                                High-quality content tailored to rank and
                                engage. We craft blogs, landing pages, and
                                product descriptions that educate, convert, and
                                support SEO goals.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>SEO Audits & Monthly Reporting</h2>
                              <p>
                                Comprehensive diagnostics to assess your current
                                SEO performance, along with easy-to-understand
                                monthly progress reports.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Local SEO</h2>
                              <p>
                                Improve your visibility in location-based
                                searches through optimized business listings,
                                reviews management, and geo-targeted content.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why SEO Matters</h2>
                      <p>
                        Search Engine Optimization is essential for long-term
                        online success. It helps your business attract qualified
                        traffic, build trust with users, and drive
                        conversions—without relying solely on paid ads.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Cost-Effective & Sustainable
                        </li>
                        <li>
                          <strong>2. </strong> Builds Brand Authority
                        </li>
                        <li>
                          <strong>3. </strong> Increases Organic Website Traffic
                        </li>
                        <li>
                          <strong>4. </strong> Enhances User Experience
                        </li>
                        <li>
                          <strong>5. </strong> Delivers Long-Term ROI
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> E-commerce & Retail
                        </li>
                        <li>
                          <strong>2. </strong> Healthcare & Wellness
                        </li>
                        <li>
                          <strong>3. </strong> Education & EdTech
                        </li>
                        <li>
                          <strong>4. </strong> Manufacturing & Industrial
                        </li>
                        <li>
                          <strong>5. </strong> B2B Services & SaaS
                        </li>
                      </ul>
                      <p>
                        <strong>Our SEO Toolkit</strong>
                      </p>
                      <p>
                        We leverage powerful tools for data, insights, and
                        performance:
                      </p>
                      <p className="toolsListWrap">
                        <span>Google Search Console</span>
                        <span>SEMrush</span>
                        <span>Ahrefs</span>
                        <span>Screaming Frog</span>
                        <span>Moz</span>
                        <span>Ubersuggest</span>
                        <span>GTmetrix</span>
                        <span>Google Analytics</span>
                        <span>Yoast SEO</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How soon will I see results from SEO?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Results typically begin appearing in 3–6 months
                              depending on your industry, competition, and
                              current site condition.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Is SEO better than paid advertising?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Both have value—ads deliver short-term results,
                              while SEO builds long-term visibility and trust
                              without ongoing spend.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can you guarantee a #1 ranking on Google?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              No honest agency can guarantee specific rankings,
                              but we guarantee ethical practices, measurable
                              progress, and performance-driven strategies.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Do I need monthly SEO services?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. SEO is a continuous effort that requires
                              ongoing optimization, content updates, and
                              adapting to algorithm changes.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            What’s included in your SEO packages?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Technical fixes, keyword research, content
                              optimization, link building, competitor tracking,
                              and monthly performance reports.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Grow Your Organic Reach</h2>
                      <p>
                        Whether you're starting from scratch or scaling an
                        existing presence, Hummingtec can build the right SEO
                        strategy to meet your goals.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> today for a
                          free SEO audit and consultation.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Healthcare Provider</h2>
                            <p>
                              <strong>Challenge:</strong> Negative patient
                              reviews affecting new patient sign-ups.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented review
                              response strategy, encouraged positive
                              testimonials, and created content to promote care
                              quality.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 4.7-star average rating
                              achieved and 2X increase in appointment bookings.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Education Institution</h2>
                            <p>
                              <strong>Challenge:</strong> Outdated negative
                              content ranking on Google.
                            </p>
                            <p>
                              <strong>Solution:</strong> Created optimized,
                              authoritative content and built backlinks to push
                              down negative results.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Positive content
                              replaced harmful articles in top search positions
                              within 3 months.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>B2B Tech Firm</h2>
                            <p>
                              <strong>Challenge:</strong> Inconsistent brand
                              presence across platforms.
                            </p>
                            <p>
                              <strong>Solution:</strong> Unified business
                              profiles, launched review campaigns, and published
                              thought-leadership content.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Improved brand
                              perception and increased partner engagement.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "Sem" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Search Engine Marketing</h2>
                      <p>(SEM & Performance Marketing)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>
                          Get Instant Visibility. Drive Conversions. Maximize
                          ROI.
                        </p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we create and manage high-performance
                          SEM and PPC campaigns designed to put your brand in
                          front of the right audience at the right time. Whether
                          it's Google Ads, Bing, or social platforms, our paid
                          media strategies are built to drive measurable results
                          and fast-track growth.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>
                                Google Ads (Search, Display, Shopping, YouTube)
                              </h2>
                              <p>
                                We build data-driven campaigns across Google’s
                                network—from search ads that capture demand to
                                video ads that build awareness.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Shopping Ads & Product Listings</h2>
                              <p>
                                For e-commerce clients, we optimize Google
                                Shopping feeds and product listings to ensure
                                your products show up in front of high-intent
                                buyers.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Mobile App Campaigns</h2>
                              <p>
                                Promote app installs and in-app actions across
                                Google and other networks using targeted
                                Universal App Campaigns (UAC).
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Remarketing Campaigns</h2>
                              <p>
                                Bring back lost visitors with highly tailored
                                remarketing ads across the Google Display
                                Network, YouTube, and social platforms.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Bing & Microsoft Ads</h2>
                              <p>
                                Expand your reach to audiences on Bing with
                                cost-effective campaigns managed in parallel
                                with Google Ads for maximum efficiency.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Conversion Rate Optimization (CRO)</h2>
                              <p>
                                We don’t just bring traffic—we optimize landing
                                pages and user flows to maximize conversions and
                                return on ad spend.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Performance Monitoring & Analytics</h2>
                              <p>
                                Transparent dashboards and detailed reporting
                                ensure you know exactly where your budget is
                                going—and how it’s performing.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Performance Marketing Works</h2>
                      <p>
                        Performance marketing gives you the power to target,
                        test, and scale with precision. Every click, impression,
                        and conversion is tracked—ensuring full control over
                        your budget and outcomes.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Immediate Visibility
                        </li>
                        <li>
                          <strong>2. </strong> Targeted Customer Acquisition
                        </li>
                        <li>
                          <strong>3. </strong> Full Budget Control
                        </li>
                        <li>
                          <strong>4. </strong> Performance-Based Results
                        </li>
                        <li>
                          <strong>5. </strong> Real-Time Optimization
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> E-commerce & Direct-to-Consumer
                        </li>
                        <li>
                          <strong>2. </strong> Healthcare & Wellness
                        </li>
                        <li>
                          <strong>3. </strong> Real Estate & Local Services
                        </li>
                        <li>
                          <strong>4. </strong> Education & Online Learning
                        </li>
                        <li>
                          <strong>5. </strong> B2B Lead Generation & SaaS
                        </li>
                      </ul>
                      <p>
                        <strong>Platforms & Tools We Use</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Google Ads</span>
                        <span>Bing Ads</span>
                        <span>Google Merchant Center</span>
                        <span>Google Analytics</span>
                        <span>Tag Manager</span>
                        <span>Meta Ads Manager</span>
                        <span>YouTube Ads</span>
                        <span>HubSpot</span>
                        <span>Hotjar</span>
                        <span>Crazy Egg</span>
                        <span>Unbounce</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How fast can I see results from SEM campaigns?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Paid campaigns typically begin driving traffic and
                              leads within 1–2 weeks of launch, with full
                              optimization in 30–60 days.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            What platforms do you advertise on?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              We primarily run campaigns on Google Ads (Search,
                              Display, YouTube), Microsoft Bing Ads, and can
                              also manage Meta and LinkedIn ads as part of
                              broader performance marketing.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            How is performance measured?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Through KPIs such as ROAS, CTR, CPC, cost per
                              acquisition (CPA), and lead quality. We provide
                              monthly reports and dashboards.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Can you help with landing page design too?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, we offer CRO-focused landing page design and
                              A/B testing services to improve your ad
                              performance and conversion rate.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            What’s the minimum budget to start?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              We typically recommend a minimum ad spend of
                              ₹30,000–₹50,000/month for initial campaign
                              testing, but we customize based on your goals.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Launch Your Next High-Performance Campaign</h2>
                      <p>
                        Ready to turn clicks into customers?Let Hummingtec
                        build, manage, and optimize your paid campaigns for
                        measurable growth.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> today for a
                          free performance audit and strategy session.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>E-commerce Store</h2>
                            <p>
                              <strong>Challenge:</strong> High bounce rate and
                              low ROAS from existing campaigns.
                            </p>
                            <p>
                              <strong>Solution:</strong> Revamped ad groups,
                              added negative keywords, optimized product feeds,
                              and tested new landing pages.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 65% increase in
                              conversions, 3.2x ROAS within 6 weeks.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Education Portal</h2>
                            <p>
                              <strong>Challenge:</strong> Low-quality leads from
                              broad campaigns.
                            </p>
                            <p>
                              <strong>Solution:</strong> Hyper-targeted
                              campaigns based on user intent and behavior,
                              coupled with lead scoring integration.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 4X qualified lead
                              volume, 40% lower cost per lead (CPL).
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>Local Service Provider</h2>
                            <p>
                              <strong>Challenge:</strong> Inconsistent bookings
                              and budget overspend.
                            </p>
                            <p>
                              <strong>Solution:</strong> Shifted to call-focused
                              campaigns with conversion tracking and dayparting.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 2.5X increase in calls
                              with a 30% reduction in cost per conversion.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "SocialMediaManage" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Social Media Marketing (SMM)</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>
                          Build Connections. Grow Your Brand. Engage
                          Authentically.
                        </p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we help brands connect with audiences
                          through thoughtful, creative, and data-driven social
                          media strategies. From storytelling to conversions, we
                          manage every aspect of your social presence to spark
                          engagement, build loyalty, and drive business growth.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>
                                Google Ads (Search, Display, Shopping, YouTube)
                              </h2>
                              <p>
                                We build data-driven campaigns across Google’s
                                network—from search ads that capture demand to
                                video ads that build awareness.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2> Social Media Strategy & Planning</h2>
                              <p>
                                We develop tailored strategies aligned with your
                                business goals, audience behavior, and industry
                                trends—mapped out month-by-month for clarity and
                                consistency.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Creation & Design</h2>
                              <p>
                                Eye-catching graphics, videos, reels, carousels,
                                and branded content designed to engage, educate,
                                and inspire.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Social Media Management</h2>
                              <p>
                                Daily posting, community management, audience
                                engagement, and inbox support across platforms
                                like Instagram, Facebook, LinkedIn, X (Twitter),
                                and YouTube.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Social Media Advertising</h2>
                              <p>
                                Targeted paid campaigns across Facebook,
                                Instagram, LinkedIn, and more—built to generate
                                traffic, leads, and conversions.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Analytics & Reporting</h2>
                              <p>
                                We track performance, refine strategies, and
                                deliver monthly reports with insights into
                                reach, engagement, clicks, and ROI.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Influencer Collaboration</h2>
                              <p>
                                Identify, negotiate, and manage influencer
                                partnerships that align with your brand and
                                speak to your target audience.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Social Media Marketing Matters</h2>
                      <p>
                        Social media is no longer optional—it's essential. With
                        billions of users scrolling every day, your audience is
                        already online. We make sure your brand is too, in the
                        right place, at the right time, with the right message.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Brand Awareness
                        </li>
                        <li>
                          <strong>2. </strong> Customer Engagement
                        </li>
                        <li>
                          <strong>3. </strong> Community Building
                        </li>
                        <li>
                          <strong>4. </strong> Lead Generation
                        </li>
                        <li>
                          <strong>5. </strong> Sales Growth
                        </li>
                      </ul>
                      <p>
                        <strong>Platforms We Support</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Instagram</span>
                        <span>Facebook</span>
                        <span>LinkedIn</span>
                        <span>X (Twitter)</span>
                        <span>YouTube</span>
                        <span>Pinterest</span>
                        <span>WhatsApp Business & Telegram</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Fashion & Lifestyle
                        </li>
                        <li>
                          <strong>2. </strong> Healthcare & Wellness
                        </li>
                        <li>
                          <strong>3. </strong> Education & Coaching
                        </li>
                        <li>
                          <strong>4. </strong> Food & Hospitality
                        </li>
                        <li>
                          <strong>5. </strong> B2B & Tech Services
                        </li>
                        <li>
                          <strong>5. </strong> Local & Regional Businesses
                        </li>
                      </ul>
                      <p>
                        <strong>Tools We Use</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Meta Business Suite</span>
                        <span>Canva</span>
                        <span>Hootsuite</span>
                        <span>Buffer</span>
                        <span>Sprout Social</span>
                        <span>Creator Studio</span>
                        <span>Adobe Express</span>
                        <span>Google Analytics</span>
                        <span>CapCut</span>
                        <span>Notion</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How often should we post on social media?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              It depends on your goals and platforms. We
                              typically recommend 3–5 times per week for
                              consistency and reach.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            What’s the difference between organic and paid
                            social media?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Organic content builds community and trust. Paid
                              ads are designed to expand reach and drive
                              conversions faster. We do both.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can you manage our social accounts completely?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. From content creation and posting to
                              community engagement and performance tracking—we
                              handle it all.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            How long before we see results?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Most clients see growth in engagement and
                              followers within the first 2–3 months. Campaigns
                              optimized for leads or sales often show results
                              faster.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            Can you create content in different languages or for
                            regional markets?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. We support multilingual content
                              creation and can tailor messaging to resonate with
                              local audiences.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Build Your Social Presence</h2>
                      <p>
                        Whether you’re launching a new brand or scaling your
                        online reach, Hummingtec’s SMM services are built to
                        create impact—one post at a time.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> today for a
                          free social media audit and content plan.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Retail Brand</h2>
                            <p>
                              <strong>Challenge:</strong> Low social engagement
                              and no clear content direction.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented a monthly
                              content calendar with branded visuals and
                              storytelling-focused posts.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 4X engagement growth,
                              steady follower gain, and increased website
                              traffic from social.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Service Business</h2>
                            <p>
                              <strong>Challenge:</strong> Low lead generation
                              from social platforms.
                            </p>
                            <p>
                              <strong>Solution:</strong> Introduced targeted
                              lead-gen ads with localized offers and
                              testimonial-based content.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Reduced cost per lead by
                              40%, and tripled inbound DMs and inquiries.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>Education Platform</h2>
                            <p>
                              <strong>Challenge:</strong> Inconsistent posting
                              and lack of student interaction.
                            </p>
                            <p>
                              <strong>Solution:</strong> Introduced reels,
                              polls, Q&As, and student success stories with
                              dedicated engagement hours.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 6X increase in follower
                              growth and strong user community development.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "ContentMarketing" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Content Marketing</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>Tell Better Stories. Build Trust. Drive Action.</p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we turn ideas into impact with
                          strategic content that attracts, engages, and
                          converts. Whether you're looking to educate, inspire,
                          or sell, our content marketing solutions are designed
                          to elevate your brand voice and deliver measurable
                          business value.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Strategy & Planning</h2>
                              <p>
                                We craft tailored strategies aligned with your
                                business goals, target audience, and customer
                                journey. From content calendars to channel
                                planning—we map it all.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Blog Writing & Long-Form Content</h2>
                              <p>
                                SEO-optimized blog posts, articles, guides, and
                                whitepapers that educate, rank, and resonate
                                with your audience.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Website Copywriting</h2>
                              <p>
                                Clear, persuasive, and brand-aligned content for
                                homepages, landing pages, service pages, and
                                product descriptions.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Email Marketing Content</h2>
                              <p>
                                Crafted email sequences, newsletters, and
                                automations designed to nurture leads and
                                re-engage customers.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Social Media Captions & Creative Content</h2>
                              <p>
                                Compelling captions, campaign messages,
                                storytelling series, and branded micro-content
                                tailored for every platform.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2> Video Scripts & Storyboarding</h2>
                              <p>
                                Scriptwriting for explainer videos, brand
                                stories, testimonials, reels, and more—designed
                                for attention and retention.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Case Studies & Testimonials</h2>
                              <p>
                                Impact-driven success stories that highlight
                                your brand’s value through real customer
                                experiences and quantifiable results.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={seoIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Performance Tracking</h2>
                              <p>
                                We monitor engagement, conversions, and SEO
                                performance to fine-tune your content and
                                maximize its impact.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Content Marketing Matters</h2>
                      <p>
                        High-quality content is the fuel behind every successful
                        digital strategy—from SEO and email campaigns to social
                        media and lead generation. It builds trust, improves
                        discoverability, and positions your business as an
                        authority in your industry.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Builds Credibility & Trust
                        </li>
                        <li>
                          <strong>2. </strong> Improves SEO & Organic Reach
                        </li>
                        <li>
                          <strong>3. </strong> Drives Conversions & Sales
                        </li>
                        <li>
                          <strong>4. </strong> Supports Every Stage of the
                          Customer Journey
                        </li>
                        <li>
                          <strong>5. </strong> Increases Engagement & Brand
                          Loyalty
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Tech & SaaS
                        </li>
                        <li>
                          <strong>2. </strong> E-commerce & Retail
                        </li>
                        <li>
                          <strong>3. </strong> Education & Training
                        </li>
                        <li>
                          <strong>4. </strong> Healthcare & Wellness
                        </li>
                        <li>
                          <strong>5. </strong> Manufacturing & Industrial
                        </li>
                        <li>
                          <strong>5. </strong> Professional Services
                        </li>
                      </ul>
                      <p>
                        <strong>Our Content Toolkit</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Google Docs</span>
                        <span>Grammarly</span>
                        <span>SurferSEO</span>
                        <span>SEMrush</span>
                        <span>Canva</span>
                        <span>Notion</span>
                        <span>Hemingway</span>
                        <span>ChatGPT</span>
                        <span>Google Analytics</span>
                        <span>WordPress</span>
                        <span>Mailchimp</span>
                        <span>HubSpot</span>
                        <span>Medium</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How often should we publish content?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Consistency is key. Most businesses benefit from
                              weekly or biweekly blog posts and ongoing web and
                              social content updates.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Do you write technical or industry-specific content?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. Our writers conduct in-depth research or
                              collaborate with your internal experts to create
                              high-quality niche content.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can you repurpose our existing content?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. We can audit and repurpose blogs,
                              whitepapers, videos, or webinars into new content
                              formats to extend their value.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Is content marketing good for SEO?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. Consistently publishing high-quality,
                              keyword-rich content significantly boosts your
                              website’s search rankings and visibility.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            How do you measure success?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              We track metrics like organic traffic, engagement,
                              conversions, time on page, bounce rate, and
                              keyword rankings depending on your goals.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Turn Content Into Conversions</h2>
                      <p>
                        Whether you need a full-scale content engine or specific
                        pieces for your campaign, Hummingtec can deliver
                        compelling content that drives business growth.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> for a free
                          content strategy consultation and sample audit.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>B2B Service Provider</h2>
                            <p>
                              <strong>Challenge:</strong> Low lead quality and
                              poor web engagement.
                            </p>
                            <p>
                              <strong>Solution:</strong> IDeveloped an inbound
                              strategy with SEO blog content and lead magnet
                              ebooks.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 3X increase in qualified
                              leads and improved time-on-site metrics.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>E-commerce Brand</h2>
                            <p>
                              <strong>Challenge:</strong> Lack of organic
                              traction and low repeat traffic.
                            </p>
                            <p>
                              <strong>Solution:</strong> Introduced lifestyle
                              blogs, product tutorials, and seasonal content
                              series.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 5X increase in organic
                              traffic and 20% higher returning customer rate.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>Training Institute</h2>
                            <p>
                              <strong>Challenge:</strong> Needed better
                              positioning in a competitive education niche.
                            </p>
                            <p>
                              <strong>Solution:</strong> Created student-focused
                              articles, FAQs, and downloadable guides.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Improved visibility for
                              30+ target keywords and boosted course signups.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "cms" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>CMS</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        Our company specializes in developing bespoke Content
                        Management Systems (CMS) tailored to meet the unique
                        needs of our clients. Our CMS solutions are designed to
                        empower clients with the ability to effortlessly manage
                        and update their digital content, ensuring their
                        websites and applications remain dynamic, relevant, and
                        engaging.
                      </p>
                      <h3>Key Features of Our CMS Solutions:</h3>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>User-Friendly Interface</h2>
                              <p>
                                We prioritize ease of use, ensuring that even
                                non-technical users can efficiently manage
                                content. Our intuitive dashboard allows for
                                quick edits, updates, and management of various
                                content types.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Customization and Flexibility</h2>
                              <p>
                                Each CMS is custom-built to align with the
                                specific requirements and branding of our
                                clients. We offer flexible design options and
                                functionality to suit different business models
                                and objectives.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Editing and Formatting</h2>
                              <p>
                                Our CMS includes a robust editor that supports a
                                variety of content formats, including text,
                                images, videos, and audio. Clients can easily
                                create, format, and publish content that
                                resonates with their audience.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>SEO Optimization Tools</h2>
                              <p>
                                Integrated SEO tools assist clients in
                                optimizing their content for search engines,
                                improving visibility and driving organic
                                traffic.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Multi-Language Support</h2>
                              <p>
                                For global reach, our CMS can support multiple
                                languages, allowing clients to cater to diverse
                                audiences.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Scalability</h2>
                              <p>
                                As businesses grow, our CMS can scale
                                accordingly. It supports increasing content
                                loads and additional functionalities as needed.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco7}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Security</h2>
                              <p>
                                We ensure that our CMS solutions are secure,
                                protecting against unauthorized access and
                                safeguarding sensitive data. Regular updates and
                                patches maintain high security standards.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Integration Capabilities</h2>
                              <p>
                                Our CMS can seamlessly integrate with other
                                systems and applications, such as CRM,
                                e-commerce platforms, and analytics tools,
                                providing a cohesive digital ecosystem.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco9} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Responsive Design</h2>
                              <p>
                                We ensure that content managed through our CMS
                                is optimized for all devices, providing a
                                seamless user experience across desktops,
                                tablets, and smartphones.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Analytics and Reporting</h2>
                              <p>
                                Built-in analytics tools enable clients to track
                                content performance, gain insights into user
                                engagement, and make data-driven decisions.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={SocialMediaIco8}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Support and Training</h2>
                              <p>
                                We offer comprehensive training and ongoing
                                support to ensure clients can fully leverage the
                                CMS capabilities.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="btmDataWrap">
                      <p>
                        Our custom CMS solutions streamline content management,
                        enhance digital presence, and empower clients to deliver
                        timely, relevant, and high-quality content to their
                        audience, ultimately driving engagement and business
                        growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "EmailMarketing" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Email Marketing & Automation</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>
                          Reach the Right Audience. At the Right Time. Every
                          Time.
                        </p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we help brands turn inboxes into
                          revenue engines with smart, targeted email marketing
                          and automation strategies. From list building and
                          segmentation to campaign design and behavioral
                          triggers—we craft journeys that convert.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Email Strategy & Planning</h2>
                              <p>
                                We define goals, build subscriber personas, and
                                design high-impact campaign calendars tailored
                                to your audience.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Email Copywriting & Design</h2>
                              <p>
                                From compelling subject lines to beautifully
                                designed layouts, we create mobile-optimized
                                emails that inspire action.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2> List Management & Segmentation</h2>
                              <p>
                                We clean, organize, and segment your email list
                                to deliver the most relevant message to the
                                right audience at the right time.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Automated Campaigns & Workflows</h2>
                              <p>
                                We set up behavior-based automations for welcome
                                series, abandoned cart recovery, re-engagement,
                                upselling, and more.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Analytics, A/B Testing & Optimization</h2>
                              <p>
                                We track open rates, click-throughs,
                                conversions, and test variations to continuously
                                refine and improve your performance.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>CRM & Platform Integrations</h2>
                              <p>
                                Seamless integration with platforms like
                                Shopify, WordPress, HubSpot, Salesforce, and
                                your CRM tools for real-time engagement.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Automation Flows We Build</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Welcome & Onboarding Sequences
                        </li>
                        <li>
                          <strong>2. </strong> Abandoned Cart Recovery
                        </li>
                        <li>
                          <strong>3. </strong> Lead Nurture & Drip Campaigns
                        </li>
                        <li>
                          <strong>4. </strong> Win-Back & Re-engagement
                        </li>
                        <li>
                          <strong>5. </strong> Product Recommendations
                        </li>
                        <li>
                          <strong>6. </strong> Post-Purchase Follow-ups
                        </li>
                        <li>
                          <strong>7. </strong> Birthday & Anniversary Emails
                        </li>
                      </ul>
                      <p>
                        <strong>Platforms We Work With</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Mailchimp</span>
                        <span>Klaviyo</span>
                        <span>HubSpot</span>
                        <span>ActiveCampaign</span>
                        <span>Moosend</span>
                        <span>MailerLite</span>
                        <span>Constant Contact</span>
                        <span>ConvertKit</span>
                        <span>Sendinblue</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> E-commerce & D2C
                        </li>
                        <li>
                          <strong>2. </strong> EdTech & Online Courses
                        </li>
                        <li>
                          <strong>3. </strong> Healthcare & Clinics
                        </li>
                        <li>
                          <strong>4. </strong> Events & Conferences
                        </li>
                        <li>
                          <strong>5. </strong> Professional Services
                        </li>
                        <li>
                          <strong>5. </strong> SaaS & B2B Solutions
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How often should we send emails?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              It depends on your audience and goals. Most brands
                              succeed with weekly or biweekly emails plus
                              automated flows for key events.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Will you manage our campaigns fully?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. We can handle everything from strategy and
                              content creation to deployment, automation, and
                              performance reporting.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can you integrate email marketing with our CRM or
                            e-commerce store?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. We support full integration with
                              platforms like HubSpot, Salesforce, Shopify, and
                              WooCommerce.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            What’s a good open and click rate?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Industry averages vary, but we aim for open rates
                              above 25% and CTRs above 3–5%, depending on your
                              niche.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            Do you support multilingual or regional email
                            campaigns?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. We create localized, language-specific
                              content and flows to match your audience segments.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Automate Your Growth</h2>
                      <p>
                        Whether you're building your first list or scaling up a
                        full lifecycle marketing system, Hummingtec delivers
                        email strategies that move your audience—and your
                        business—forward.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> today for a
                          free email audit and automation strategy session.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Online Retailer</h2>
                            <p>
                              <strong>Challenge:</strong> High cart abandonment
                              rate.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented an
                              abandoned cart recovery flow with personalized
                              product reminders and incentives.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 18% recovery rate and
                              2.7X increase in completed sales.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Professional Training Service</h2>
                            <p>
                              <strong>Challenge:</strong> Poor lead follow-up
                              and low webinar attendance.
                            </p>
                            <p>
                              <strong>Solution:</strong> Created a drip campaign
                              with educational emails and reminders tied to
                              sign-up behavior.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 60% higher attendance
                              and increased course enrollments.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>Subscription Product</h2>
                            <p>
                              <strong>Challenge:</strong> Low engagement from
                              inactive users.
                            </p>
                            <p>
                              <strong>Solution:</strong> Automated win-back
                              campaign triggered by inactivity and personalized
                              offers.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 28% reactivation rate
                              and reduced churn.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "Cro" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Conversion Rate Optimization (CRO)</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>
                          Turn Visitors into Customers. Maximize Every Click.
                        </p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          At Hummingtec, we help you get more value from the
                          traffic you already have. Our Conversion Rate
                          Optimization (CRO) strategies are built to reduce
                          friction, enhance user experience, and boost the
                          percentage of visitors who take meaningful
                          action—whether it’s filling a form, making a purchase,
                          or booking a service.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Website & Funnel Audit</h2>
                              <p>
                                Comprehensive analysis of your website, landing
                                pages, and sales funnels to identify drop-off
                                points, usability issues, and optimization
                                opportunities.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>A/B Testing & Multivariate Testing</h2>
                              <p>
                                We test variations of copy, design, CTAs,
                                layouts, and user flows to determine what drives
                                the best results—based on real user behavior.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2> Behavioral Analytics</h2>
                              <p>
                                We use tools like heatmaps, session recordings,
                                and scroll maps to understand how users interact
                                with your site—and why they don’t convert.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Landing Page Optimization</h2>
                              <p>
                                We design and optimize high-converting landing
                                pages tailored to different campaigns, devices,
                                and audience segments.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>E-commerce Optimization</h2>
                              <p>
                                From checkout simplification to product page
                                enhancements—we reduce friction at every step of
                                the buyer’s journey.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Form Optimization & Lead Capture</h2>
                              <p>
                                Simplified forms, smarter CTAs, and progressive
                                profiling help increase form submissions and
                                lead quality.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco6} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Continuous Optimization & Reporting</h2>
                              <p>
                                CRO is not a one-time task—it’s a process. We
                                monitor performance and iterate constantly to
                                keep improving your conversion outcomes.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why CRO Is Essential</h2>
                      <p>
                        Driving traffic to your site is only half the equation.
                        Without conversion optimization, you're leaving revenue
                        on the table. CRO turns clicks into customers and
                        traffic into growth.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Increases ROI Without More Ad
                          Spend
                        </li>
                        <li>
                          <strong>2. </strong> Enhances User Experience
                        </li>
                        <li>
                          <strong>3. </strong> Reduces Bounce Rates
                        </li>
                        <li>
                          <strong>4. </strong> Improves Lead Quality & Sales
                        </li>
                        <li>
                          <strong>5. </strong> Data-Driven, Measurable
                          Improvements
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> E-commerce
                        </li>
                        <li>
                          <strong>2. </strong> SaaS & Tech
                        </li>
                        <li>
                          <strong>3. </strong> Education & EdTech
                        </li>
                        <li>
                          <strong>4. </strong> Healthcare & Clinics
                        </li>
                        <li>
                          <strong>5. </strong> Lead Generation Services
                        </li>
                        <li>
                          <strong>5. </strong> Real Estate & Local Businesses
                        </li>
                      </ul>
                      <p>
                        <strong>Tools We Use</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Google Optimize</span>
                        <span>Hotjar</span>
                        <span>Crazy Egg</span>
                        <span>Unbounce</span>
                        <span>Optimizely</span>
                        <span>VWO</span>
                        <span>Google Analytics</span>
                        <span>Tag Manager</span>
                        <span>HubSpot</span>
                        <span>FullStory</span>
                        <span>Zoho Pagesense</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How is CRO different from SEO or UX design?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              CRO focuses specifically on improving the actions
                              users take—like purchases or form submissions. It
                              works alongside SEO and UX, but has a direct
                              revenue goal.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How long does it take to see results?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Many CRO experiments yield results within 2–4
                              weeks, but continuous testing over months brings
                              the most sustainable growth.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can you optimize my existing landing pages?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. We analyze, test, and optimize your existing
                              pages or build high-converting new ones from
                              scratch.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Do you support mobile and app CRO?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. We optimize for both web and mobile
                              experiences, ensuring seamless performance across
                              all devices.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            Is CRO only for high-traffic websites?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              No. Even websites with moderate traffic can
                              benefit from CRO, especially if you're running ads
                              or want to improve lead quality.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Maximize Your Conversions</h2>
                      <p>
                        Already investing in marketing? Let’s make every click
                        count.Hummingtec’s CRO team is ready to turn more of
                        your visitors into paying customers.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> for a free
                          conversion audit and CRO consultation.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>B2B SaaS Platform</h2>
                            <p>
                              <strong>Challenge:</strong> High website traffic,
                              low demo requests.
                            </p>
                            <p>
                              <strong>Solution:</strong> Redesigned landing
                              pages with focused CTAs and simplified lead
                              capture forms.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 48% increase in demo
                              sign-ups in 2 months.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>E-commerce Brand</h2>
                            <p>
                              <strong>Challenge:</strong> High cart abandonment
                              rate.
                            </p>
                            <p>
                              <strong>Solution:</strong> Optimized checkout
                              flow, trust signals, and exit-intent offers.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 32% decrease in
                              abandonment and a 22% increase in sales.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>Education Website</h2>
                            <p>
                              <strong>Challenge:</strong> Poor
                              lead-to-enrollment conversion.
                            </p>
                            <p>
                              <strong>Solution:</strong> Introduced dynamic
                              content personalization and mobile-first redesign.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Lead-to-enrollment rate
                              doubled within 90 days.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "WebAnalytics" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Web Analytics & Reporting</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "Orm" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Online Reputation Management (ORM)</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap innerPageIntroData">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="sticyDiv">
                      <div className="titleWrap">
                        <p>
                          Protect Your Brand. Build Trust. Grow with Confidence.
                        </p>
                      </div>
                      <div className="dataWrap">
                        <p>
                          Your brand’s reputation is your most valuable asset.
                          At Hummingtec, we help you take control of the
                          conversation with proactive Online Reputation
                          Management (ORM) solutions—monitoring what’s being
                          said, addressing concerns, and showcasing the positive
                          stories that define your business.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Reputation Monitoring</h2>
                              <p>
                                We track mentions of your brand across Google,
                                review platforms, social media, and forums—so
                                you’re always the first to know what’s being
                                said.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Review Management & Response</h2>
                              <p>
                                From Google Reviews to industry-specific
                                platforms, we help you manage, respond to, and
                                encourage reviews—turning feedback into
                                opportunities.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco3} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2> Crisis Management</h2>
                              <p>
                                In the event of negative publicity, we guide
                                your brand with timely, strategic responses and
                                content designed to rebuild trust.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Suppression & De-ranking</h2>
                              <p>
                                We help reduce the visibility of outdated or
                                harmful content in search results using SEO and
                                content publishing techniques.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco4} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Reputation Building Campaigns</h2>
                              <p>
                                We proactively build your online presence with
                                testimonials, case studies, PR content, and
                                authority-building articles.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Brand Sentiment Analysis</h2>
                              <p>
                                Using AI-powered tools, we assess public
                                sentiment and help you make informed decisions
                                about messaging, engagement, and brand strategy.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why ORM Matters</h2>
                      <p>
                        In a digital-first world, one bad review—or no reviews
                        at all—can make or break a customer’s decision. ORM
                        helps you shape public perception, respond to feedback,
                        and build a credible, trusted online presence.
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Builds Trust & Credibility
                        </li>
                        <li>
                          <strong>2. </strong> Improves Search Visibility
                        </li>
                        <li>
                          <strong>3. </strong> Influences Customer Decisions
                        </li>
                        <li>
                          <strong>4. </strong> Reduces Negative Impact
                        </li>
                        <li>
                          <strong>5. </strong> Supports SEO & Brand Growth
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Industries We Support</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Healthcare & Clinics
                        </li>
                        <li>
                          <strong>2. </strong> Education & Institutions
                        </li>
                        <li>
                          <strong>3. </strong> E-commerce & Retail
                        </li>
                        <li>
                          <strong>4. </strong> Financial Services
                        </li>
                        <li>
                          <strong>5. </strong> Hospitality & Real Estate
                        </li>
                        <li>
                          <strong>5. </strong> Professional Services &
                          Consultants
                        </li>
                      </ul>
                      <p>
                        <strong>Platforms We Monitor</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Google Reviews</span>
                        <span>Facebook</span>
                        <span>Trustpilot</span>
                        <span>Glassdoor</span>
                        <span>Yelp</span>
                        <span>JustDial</span>
                        <span>Practo</span>
                        <span>Quora</span>
                        <span>Twitter</span>
                        <span>Reddit</span>
                        <span>LinkedIn</span>
                        <span>Industry Forums</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Can you remove negative reviews or articles?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              While we can’t delete content we don’t control, we
                              use SEO and content strategies to suppress and
                              outrank negative items effectively.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How do you encourage positive reviews?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              We create review request flows via email, SMS, or
                              in-app prompts and help you build a reputation
                              strategy that fits your audience.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            How long does it take to see results?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              ORM improvements can begin within weeks, but
                              significant changes to search visibility or
                              ratings typically take 2–4 months.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Do you support Glassdoor or employee review sites?
                          </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes. We provide strategies for employer branding
                              and internal communications to improve reviews and
                              responses on platforms like Glassdoor.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            Is ORM only reactive?
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              No. Our approach is proactive—we focus on building
                              positive brand sentiment, not just cleaning up
                              issues after they arise.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Let’s Take Control of Your Online Image</h2>
                      <p>
                        Your reputation is too important to leave to chance.Let
                        Hummingtec help you monitor, protect, and enhance your
                        brand's presence—wherever your audience is looking.
                      </p>
                      <p>
                        <strong>
                          <Link to={"/Contact"}>Contact us</Link> today for a
                          free reputation audit and strategy session.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Healthcare Provider</h2>
                            <p>
                              <strong>Challenge:</strong> Negative patient
                              reviews affecting new patient sign-ups.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented review
                              response strategy, encouraged positive
                              testimonials, and created content to promote care
                              quality.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 4.7-star average rating
                              achieved and 2X increase in appointment bookings.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Education Institution</h2>
                            <p>
                              <strong>Challenge:</strong> Outdated negative
                              content ranking on Google.
                            </p>
                            <p>
                              <strong>Solution:</strong> Created optimized,
                              authoritative content and built backlinks to push
                              down negative results.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Positive content
                              replaced harmful articles in top search positions
                              within 3 months.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr3">
                          <div className="dataWrap">
                            <h2>B2B Tech Firm</h2>
                            <p>
                              <strong>Challenge:</strong> Inconsistent brand
                              presence across platforms.
                            </p>
                            <p>
                              <strong>Solution:</strong> Unified business
                              profiles, launched review campaigns, and published
                              thought-leadership content.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Improved brand
                              perception and increased partner engagement.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg3}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "CustomerEngagement" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Customer Engagement</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        Our company specializes in developing bespoke backend
                        portals for clients, designed to foster effective
                        engagement with their customers. This portal serves as a
                        central hub for client-customer interactions,
                        streamlining communication and enhancing customer
                        service. Here's how our solution empowers our clients:
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>User-Friendly Dashboard</h2>
                              <p>
                                The portal features an intuitive dashboard that
                                provides clients with a comprehensive overview
                                of customer interactions, feedback, and
                                analytics. This centralized view enables clients
                                to make informed decisions and respond promptly
                                to customer needs.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Customer Interaction Tools</h2>
                              <p>
                                We integrate various tools for direct
                                communication, such as messaging systems, email,
                                and chat options. These tools allow for
                                real-time interactions, enabling our clients to
                                address customer queries, provide support, and
                                maintain ongoing engagement.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Feedback and Survey Management</h2>
                              <p>
                                The portal includes features for collecting and
                                managing customer feedback, including surveys
                                and review systems. This helps our clients
                                gather valuable insights into customer
                                satisfaction and preferences.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Customization and Personalization</h2>
                              <p>
                                We understand that every business is unique. Our
                                portal is highly customizable, allowing clients
                                to tailor features, branding, and
                                functionalities according to their specific
                                business needs and customer profiles.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Data Analytics and Reporting</h2>
                              <p>
                                Advanced analytics tools are embedded to track
                                customer engagement, behavior, and feedback.
                                Clients can generate detailed reports, helping
                                them to understand customer trends and measure
                                the effectiveness of their strategies.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco6}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Integration with CRM and Marketing Tools</h2>
                              <p>
                                The portal seamlessly integrates with existing
                                Customer Relationship Management (CRM) systems
                                and marketing tools, ensuring a unified approach
                                to customer management and outreach.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco7}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Security and Data Privacy</h2>
                              <p>
                                We prioritize security and data privacy. The
                                portal is built with robust security protocols
                                to protect sensitive customer information and
                                ensure compliance with data protection
                                regulations.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco8}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Scalability and Flexibility</h2>
                              <p>
                                Our solution is scalable, accommodating the
                                growing needs of our clients. Whether it's
                                expanding the customer base or adding new
                                functionalities, the portal evolves with the
                                business.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={SocialMediaIco8}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Support and Training</h2>
                              <p>
                                We provide comprehensive training and ongoing
                                support to ensure clients can maximize the
                                benefits of the portal.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="btmDataWrap">
                      <p>
                        This backend portal is not just a platform; it's a
                        strategic tool that empowers our clients to build
                        stronger relationships with their customers, enhance
                        customer satisfaction, and drive business growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DigitalMarketingDetails;
